<template>
    <!-- null인 경우 선택되지 않기 때문에 빈 문자열로 값 세팅 -->
    <div :class="['selectbox-wrap', {disabled: props.isDisabled}]">
        <select
            v-bind="$attrs"
            :class="[
                'selectbox',
                {
                    'text-center': props.textAlignCenter,
                    hasarrow: !props.isDisabled,
                    'has-bg': props.bg,
                },
            ]"
            :value="props.title || props.modelValue || ''"
            :disabled="props.isDisabled"
            @change="handleChange"
        >
            <option
                v-if="props.title"
                class="title"
                :disabled="true"
                :key="'placeholder'"
                :value="props.title"
            >
                {{ props.title }}
            </option>
            <option
                class="option"
                v-for="item in props.optionList"
                :key="`${item.text}_${item.value}`"
                :value="item.value || ''"
            >
                {{ item.text }}
            </option>
        </select>
    </div>
</template>

<script setup lang="ts">
export type SelectValueT = null | string | number;

export interface BaseSelectOptionsI {
    text: string;
    value?: SelectValueT;
}

const emits = defineEmits<{
    (e: 'update:modelValue', value: SelectValueT): void;
    (e: 'change', event: Event): void;
}>();

const props = defineProps<{
    name?: string;
    title?: string;
    optionList: BaseSelectOptionsI[];
    modelValue?: SelectValueT;
    hasError?: boolean;
    nullable?: boolean;
    textAlignCenter?: boolean;
    readonly?: boolean;
    isDisabled?: boolean;
    bg?: boolean;
}>();

const handleChange = (e: Event) => {
    const target = e.target as HTMLSelectElement;
    const value = props.nullable && !target.value ? null : target.value;

    emits('update:modelValue', value);
    emits('change', e);
};
</script>

<style lang="scss" scoped>
.selectbox-wrap {
    position: relative;
    display: inline-flex;
    min-width: 120px;
    height: fit-content;
    border-radius: 6px;

    .selectbox {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        padding: 0 30px 0 12px;
        width: 100%;
        height: 40px;
        font-size: 14px;
        border: solid 1px $black_16;
        border-radius: 6px;
        cursor: pointer;
        transition: 0.05s;
        -webkit-appearance: none;
        appearance: none /*menulist*/ !important;

        &.hasarrow {
            background: calc(100% - 9px) 12px
                    linear-gradient(
                        rgba(255, 255, 255, 0.5),
                        rgba(255, 255, 255, 0.5)
                    ),
                url('@/assets/svg/icn_arrow_down.svg') no-repeat center right
                    10px / 10px;

            &:hover,
            &:focus {
                background: calc(100% - 9px) 12px
                        linear-gradient(
                            rgba(255, 255, 255, 0.1),
                            rgba(255, 255, 255, 0.1)
                        ),
                    url('@/assets/svg/icn_arrow_down.svg') no-repeat center
                        right 10px / 10px;
            }
            &.has-bg {
                border: none;
                background: $bg-field url(/src/assets/svg/icn_arrow_down.svg)
                    no-repeat center right 10px / 10px;
                &:hover,
                &:focus {
                    border: 1px solid $ele-outline-table;
                }
            }
        }

        &:hover {
            color: black;
            border: 1px solid $black_40;
        }

        &:focus {
            color: black;
            border: solid 1px $primary;
        }

        &.disabled,
        &:disabled {
            color: $black_16;
            background: calc(100% - 9px) 12px
                    linear-gradient($black_08, $black_08),
                url('@/assets/svg/icn_arrow_down.svg') no-repeat center right
                    10px / 10px;
            cursor: not-allowed;
            opacity: 1;

            &:hover {
                border: solid 1px $black_16;
            }
        }
    }
}
</style>
